import Details from '@/app/routes/ChargeCenter/Details';
import { gridConnectionsRoute } from '@/modules/charge-center/grid-connections/route';
import { createRoute } from '@tanstack/react-router';

export const gridConnectionDetailsRoute = createRoute({
  getParentRoute: () => gridConnectionsRoute,
  path: '$gridConnectionId',
  component: () => <Details />,
});
